import { LoadingOutline } from '@olist/design-system-icons';
import styled, { keyframes, css } from 'styled-components';

const DEFAULT_VALUE_VARIATION = 'primary';
const DEFAULT_VALUE_SIZE = 'medium';
const loadingAnimation = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const Loading = styled(LoadingOutline)(({ variation = DEFAULT_VALUE_VARIATION, size = DEFAULT_VALUE_SIZE, theme: { olist: { components: { loading }, }, }, }) => css `
    position: absolute;
    animation: ${loadingAnimation};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    fill: ${loading.variation[variation].color};

    width: ${loading.size[size].width};
    height: ${loading.size[size].height};

    path {
      fill: ${loading.variation[variation].color};
    }
  `);

export { Loading as default };
